export const NOTIFICATIONS_FETCHED = "NOTIFICATIONS_FETCHED";
export const NOTIFICATIONS_FETCHING = "NOTIFICATIONS_FETCHING";
export const NOTIFICATIONS_FAILURE = "NOTIFICATIONS_FAILURE";
export const NOTIFICATION_DELETED = "NOTIFICATIONS_DELETED";
export const NOTIFICATION_INSERT = "NOTIFICATION_INSERT";
export const NOTIFICATION_ALL_READ = "NOTIFICATION_ALL_READ";
export const NOTIFICATION_ALL_DELETE = "NOTIFICATION_ALL_DELETE";
export const NOTIFICATION_READ = "NOTIFICATION_READ";
